import { FC, useMemo } from 'react';
import { SubmitButton } from '@/components/form/submit-button';
import { Button } from '@/components/ui/button';
import { useForm } from '@/forms/hooks/use-form';
import { GroupFieldValues } from '@/forms/schemas/group/field-values';
import { buildGroupFormSchema } from '@/forms/schemas/group/schema';
import { FieldOption } from '@/forms/types/field-option';
import { DrawerContentFormLayout } from '@/layouts/drawer-content-form-layout';

export type CreateGroupFormProps = {
  canAssignAnyOrganisation: boolean;
  organisationName: string;
  organisationOptions: FieldOption<number>[];
  onCancel: () => void;
  onSubmit: (values: GroupFieldValues) => void;
};

export const CreateGroupForm: FC<CreateGroupFormProps> = ({
  canAssignAnyOrganisation,
  organisationName,
  organisationOptions,
  onCancel,
  onSubmit,
}) => {
  const formSchema = useMemo(
    () =>
      buildGroupFormSchema({
        canAssignAnyOrganisation,
        organisationName,
        organisationOptions,
      }),
    [canAssignAnyOrganisation, organisationName, organisationOptions],
  );

  const { fieldItems, formState, handleSubmit, trigger } = useForm({
    schema: formSchema,
    onSubmit,
  });

  if (formState.submitCount > 0) {
    trigger();
  }

  return (
    <DrawerContentFormLayout
      buttonItems={[
        <Button key="cancel" onClick={onCancel} variant="secondary">
          Cancel
        </Button>,
        <SubmitButton key="submit" text="Create Group" />,
      ]}
      fieldItems={fieldItems}
      onSubmit={handleSubmit}
    />
  );
};
